import { motion } from "framer-motion";

export default function Reveal({ children, delay = 0, y = 24, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: [0.2, 0.8, 0.2, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function SectionLabel({ children, testId }) {
  return (
    <div className="flex items-center gap-4" data-testid={testId}>
      <span className="h-px w-10 bg-[#d4af37]" />
      <span className="section-label">{children}</span>
    </div>
  );
}
